export const OLD_USER_CENTER_URL = process.env.VUE_APP_OLD_USER_CENTER_URL; //会员中心
export const CDN = process.env.VUE_APP_OSS_CDN;
